/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_InsertInputs */

const en_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Insert`)
};

const es_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserción dividida`)
};

const fr_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion fractionnée`)
};

const de_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilter Einschub`)
};

const ja_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割挿入`)
};

const zh_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拆分插入`)
};

const ar_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدراج مقسم`)
};

const id_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisipan Terpisah`)
};

const it_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento diviso`)
};

const ru_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раздельная вставка`)
};

const pt_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserção dividida`)
};

const ko_split_insert = /** @type {(inputs: Split_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분할 삽입`)
};

/**
* | output |
* | --- |
* | "Split Insert" |
*
* @param {Split_InsertInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const split_insert = /** @type {((inputs?: Split_InsertInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_InsertInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_split_insert(inputs)
	if (locale === "es") return es_split_insert(inputs)
	if (locale === "fr") return fr_split_insert(inputs)
	if (locale === "de") return de_split_insert(inputs)
	if (locale === "ja") return ja_split_insert(inputs)
	if (locale === "zh") return zh_split_insert(inputs)
	if (locale === "ar") return ar_split_insert(inputs)
	if (locale === "id") return id_split_insert(inputs)
	if (locale === "it") return it_split_insert(inputs)
	if (locale === "ru") return ru_split_insert(inputs)
	if (locale === "pt") return pt_split_insert(inputs)
	return ko_split_insert(inputs)
});